<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3" style="height: 330px;">
            <div class="container mb-0 mt-5">
                <div class="row">
                    <div class="col-lg-12 mt-4">
                        <div class="text-center">
                            <h1 class="text-white" data-aos="fade-left">Promo & Berita</h1>
                            <p class="text-white" data-aos="fade-right">Berita dan informasi terbaru tentang Awan</p>
                        </div>
                    </div>
                    <div class="col-lg-12" data-aos="fade-left">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="Cari berita" style="border-color: #233dff;" v-model="SearchSelected">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" @click="get_blog()" style="background-color: #233dff;" type="button"><i class="bx bx-search"></i></button>
                                            </div>
                                        </div>
                                        <div class="mt-2" v-if="SearchSelected != ''">
                                            <span class="font-size-12">Keyword :</span>
                                            <span class="badge badge-pill badge-primary">{{SearchSelected}}</span>
                                            <span class="badge badge-pill badge-danger" style="cursor: pointer" @click="SearchSelected = ''">x</span>
                                        </div>
                                        <div class="mt-2">
                                            <span class="font-size-12">Category :</span>
                                            <span class="badge badge-pill badge-soft-primary" style="cursor:pointer" @click="switchCategory('')">Semua Kategori</span>
                                            <span v-for="item in Category" class="badge badge-pill badge-soft-primary" style="cursor:pointer" @click="switchCategory(item.id)">{{item.name}}</span>
                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-white pt-3">
            <div class="container">
                <div class="row mb-2">
                    <div class="col-8">
                        <div class="mt-2">
                            <span class="font-size-12">Showing {{blog.length}} results</span>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="float-right">
                            <div class="btn-group">
                                <button type="button" class="btn dropdown-toggle" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"> {{text}} <i class="fa fa-sort"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click="get_blog('DESC')">Postingan terbaru</a>
                                    <a class="dropdown-item" href="#" @click="get_blog('ASC')">Postingan terlama</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12" v-if="blog.length == 0 && blog_ready == true">
                        <div class="text-center">
                            <img src="awan/images/404.svg" alt="tidak-ada-post-ditemukan" class="img-fluid" style="width: 200px">
                            <h5 class="mt-3">Blog tidak ditemukan</h5>
                        </div>
                    </div>
                    <div class="col-lg-12" v-if="blog.length == 0 && blog_ready == false">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6" v-for="item in blog">
                        <div class="blog-box mb-4 mb-xl-2" @click="goDetail(item.slug)">
                            <div class="position-relative">
                                <img :src="item.image" :alt="item.slug" class="rounded img-fluid mx-auto d-block">
                                <div class="badge badge-success blog-badge font-size-11">{{item.tag}}</div>
                            </div>
                            <div class="mt-4 text-muted">
                                <p class="mb-2"><i class="bx bx-calendar mr-1"></i> {{item.created_at.replace('T',' ')}}</p>
                                <h5 class="mb-3">{{item.title}}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: 'Blog',
    components: {
    },
    data() {
        return {
            blog_ready: false,
            blog: [],
            SearchSelected: '',
            CategorySelected: '',
            Category: [],
            text: 'Urutkan berdasarkan tanggal'
        }
    },
    methods: {
        getCategory() {
            axios({
                method: 'get',
                url: '/v1/admin/blog_category',
            }).then((response) => {
                this.Category = response.data
            }).catch((error) => {
                console.log(error)
            })
        },
        switchCategory(id) {
            // change class 
            this.CategorySelected = id
            this.get_blog()
        },
        get_blog(sort = false){
            this.blog = []
            this.blog_ready = false
            var query = {
                search: this.SearchSelected,
                id_category: this.CategorySelected,
                hide_description: false,
                sort: 'DESC'
            }
            if (sort) {
                query.sort = sort
            }
            axios({
                method:'get',
                url: '/v1/get_blogs',
                params: query
            }).then((response) => {
                this.blog_ready = true
                this.blog = response.data
                console.log(this.blog)
            }).catch((error) => {
                this.blog_ready = true
                console.log(error)
            })
        },
        goDetail(slug){
            this.$router.push({ name: 'BlogDetail', params: { slug: slug } })
        }
    },
    mounted() {
        // title
        document.title = 'Berita dan Promo'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
        // call blog
        this.get_blog()
        this.getCategory()
    },
}
</script>